import { MagistralDrugRawMaterial } from '@dreryk/drerykweb-medicine-api';

export const hasRpwMagistralDrugInMedicineRawMaterials = (
   magistralDrugRawMaterials: MagistralDrugRawMaterial[]
): boolean => {
   return magistralDrugRawMaterials.some(({ rpw }) => rpw);
};
